import { gsap } from 'gsap';

const initVideoOverlays = (triggers) => {
    const body = document.querySelector('body');
    const videoOverlay = document.querySelector('.js-video-overlay');
    let videoTarget = null;
    let videoClose = null;
    if (videoOverlay) {
        videoTarget = videoOverlay.querySelector('.js-video-target');
        videoClose = videoOverlay.querySelector('.js-video-overlay-close');
    }

    const closeOverlay = () => {
        body.classList.remove('stop-scrolling');
        videoOverlay.classList.remove('is-active');
        gsap.to(videoOverlay, {
            autoAlpha: 0,
            duration: 0.2,
            onComplete: () => {
                videoTarget.src = '';
                gsap.set(videoTarget, {
                    autoAlpha: 0,
                    y: 100,
                });
            },
        });
    };

    const openOverlay = (src) => {
        body.classList.add('stop-scrolling');
        videoOverlay.classList.add('is-active');
        gsap.to(videoOverlay, {
            autoAlpha: 1,
            onComplete: () => {
                videoTarget.src = src;
                gsap.to(videoTarget, {
                    autoAlpha: 1,
                    y: 0,
                });
            },
        });
    };

    gsap.set(videoOverlay, {
        autoAlpha: 0,
    });

    gsap.set(videoTarget, {
        autoAlpha: 0,
        y: 100,
    });

    if (videoOverlay && videoTarget) {
        triggers.forEach((trigger) => {
            const src = trigger.dataset.src;

            trigger.addEventListener('click', () => {
                openOverlay(src);
            });
        });

        videoClose.addEventListener('click', () => {
            closeOverlay();
        });

        window.addEventListener('keyup', (e) => {
            if (
                e.key === 'Escape' &&
                body.classList.contains('stop-scrolling')
            ) {
                closeOverlay();
            }
        });
    }
};

export default initVideoOverlays;
